// Estado vazio (DESIGN §5.13) e estado de erro de carga. Sempre com uma saída (ação).
import type { ReactNode } from "react";
import { cn } from "../lib/cn";
import { Botao } from "./Botao";
import { Icones, type TipoIcone } from "./icones";

export interface PropsVazio {
  titulo: ReactNode;
  texto?: ReactNode;
  icone?: TipoIcone;
  /** Uma ação só (Botao secundário/texto; primário só se for a ação da tela). */
  acao?: ReactNode;
  className?: string;
}

export function Vazio({ titulo, texto, icone: Icone, acao, className }: PropsVazio) {
  return (
    <div className={cn("px-6 py-10 text-center", className)}>
      {Icone && <Icone size={40} aria-hidden className="mx-auto mb-3 text-texto-3" />}
      <h2 className="text-h2 text-tinta">{titulo}</h2>
      {texto && <p className="mx-auto mt-2 max-w-72 text-apoio text-texto-2">{texto}</p>}
      {acao && <div className="mt-5 flex justify-center">{acao}</div>}
    </div>
  );
}

/** Erro de carga com "Tentar de novo" (DESIGN §5.20 e §6.1). */
export function ErroCarga({
  texto = "Algo deu errado do nosso lado. Tente de novo em instantes.",
  aoTentar,
  className,
}: {
  texto?: string;
  aoTentar?: () => void;
  className?: string;
}) {
  return (
    <div role="alert" className={cn("flex flex-col items-center px-6 py-10 text-center", className)}>
      <Icones.erro size={32} aria-hidden className="mb-3 text-erro" />
      <p className="max-w-72 text-apoio text-texto-2">{texto}</p>
      {aoTentar && (
        <Botao variante="secundario" className="mt-5" onClick={aoTentar}>
          Tentar de novo
        </Botao>
      )}
    </div>
  );
}

/** Rota acessada sem permissão (DESIGN §6). */
export function SemPermissao({ acao }: { acao?: ReactNode }) {
  return (
    <Vazio
      icone={Icones.bloqueado}
      titulo="Esta área é da gerência"
      texto="Fale com quem gerencia a unidade."
      acao={acao}
    />
  );
}
